export const colourConfig: Record<string, string> = {
  beech: '#EAE1C3',
  beige: '#EAE1C3',
  black: '#000000',
  blue: '#4169AA',
  brown: 'var(--color-global-bronze900)',
  chrome: '#EDEDED',
  clear: '#FAFAFA',
  cream: '#F8F6E3',
  gold: '#FAD770',
  green: 'var(--color-global-green500)',
  grey: '#BABABA',
  ivory: '#FFFFF0',
  mahogany: '#C04000',
  maple: '#BB9351',
  metallic: '#878787',
  multi: 'linear-gradient(135deg, #FF0000 0%, #F3F72E 35.94%, #FF00C7 53.12%, #00FF38 71.87%, #0500FF 100%)',
  natural: '#FFF4EA',
  nude: '#E3BC9A',
  oak: '#D8B589',
  orange: '#FF9900',
  pine: '#EED5AE',
  pink: '#DE007B',
  purple: '#7D277B',
  red: '#D91218',
  silver: 'rgba(0, 0, 0, 0.2)',
  'stainless steel': 'rgba(0, 0, 0, 0.1)',
  tan: '#FFE49F',
  walnut: '#773F1A',
  white: '#FFFFFF',
  yellow: '#FFE600',
  alloy: '#A0A0A0',
  gunmental: '#6E6E6E',
  espresso: '#634616',
};
